import { render } from "./SignupPage.vue?vue&type=template&id=acc10d38&scoped=true"
import script from "./SignupPage.vue?vue&type=script&lang=js"
export * from "./SignupPage.vue?vue&type=script&lang=js"

import "../assets/css/Signup.css?vue&type=style&index=0&id=acc10d38&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-acc10d38"]])

export default __exports__